// Display constants for the Risk desk; the figures come from GET /api/admin/risk

export const RISK_PERIODS = [
  { value: "today", label: "Today" },
  { value: "week", label: "This week" },
  { value: "month", label: "This month" },
  { value: "year", label: "This year" },
];

// An account's place against its drawdown limits
export const RISK_STATUS = {
  ok: { label: "OK", tone: "success" },
  watch: { label: "Watch", tone: "warning" },
  breached: { label: "Breached", tone: "danger" },
};

// The "Action required" rows, in order. `count` words the summary; `columns` are the modal's.
// Alerts the API returns as null (hedge cut-off, back to breakeven) need the PMM hedge and are
// shown as not tracked yet.
export const RISK_ALERTS = [
  {
    key: "dailyLossToday",
    summary: (n) => `${n} ${n === 1 ? "account" : "accounts"} hit daily loss today`,
    title: "Hit daily loss today",
    crossCheck: true,
    columns: ["login", "email", "dailyDd"],
  },
  {
    key: "maxLossToday",
    summary: (n) => `${n} ${n === 1 ? "account" : "accounts"} hit max loss today`,
    title: "Hit max loss today",
    crossCheck: true,
    columns: ["login", "email", "equity"],
  },
  {
    key: "hedgeCutOff",
    summary: () => "Accounts reaching the hedge cut off limit today",
    title: "Hedge cut off limit reached",
    crossCheck: true,
    columns: ["login", "status"],
  },
  {
    key: "profitTarget",
    summary: (n) => `${n} ${n === 1 ? "account" : "accounts"} hit 10% profits`,
    title: "Cumulative gain trigger",
    columns: ["login", "status", "profitPct"],
  },
  {
    key: "backToBreakeven",
    summary: () => "Unhedged accounts back to breakeven",
    title: "Unhedged accounts at BE+",
    columns: ["login", "profitPct"],
  },
];
